import { Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import { DropdownItem } from "../Interfaces/dropdownInterfaces";
import {
  IAddEditRoleFormValues,
  IAssignRoleFormValues,
  IPermissionItem,
  IPermissionTreeNode,
  IPermissionsTableReport,
  IPermissionsTableSearchParam,
  IRolesTableReport,
  IRolesTableSearchParam,
  IUserRolesTableReport,
  IUserRolesTableSearchParam,
} from "../Interfaces/roleAndPermissionsInterfaces";
import {
  deleteRequest,
  getRequest,
  getTable,
  postRequest,
  putRequest,
} from "./requestTemplates";

export const getPermissions = (): Promise<IPermissionItem[]> =>
  getRequest("/v1/roleAndPermission/GetPermissions");

export const getPermissionTree = (): Promise<IPermissionTreeNode[]> =>
  getRequest("/v1/roleAndPermission/GetPermissionTree");

export const addRole = (
  formValues: IAddEditRoleFormValues
): Promise<Packet<boolean>> =>
  postRequest("/v1/roleAndPermission/addRole", formValues);

export const editRole = (
  formValues: IAddEditRoleFormValues
): Promise<Packet<boolean>> =>
  putRequest("/v1/roleAndPermission/editRole", formValues);

export const deleteRole = (roleId: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/roleAndPermission/deleteRole?roleId=${roleId}`);

export const getRolesTable = (
  searchParam: IRolesTableSearchParam,
  offset: number | null,
  pageSize: number | null
): Promise<Report<IRolesTableReport>> =>
  getTable<IRolesTableSearchParam, IRolesTableReport>(
    "/v1/roleAndPermission/roleTable",
    searchParam,
    offset,
    pageSize
  );

export const getUserRolesTable = (
  searchParam: IUserRolesTableSearchParam,
  offset: number | null,
  pageSize: number | null
): Promise<Report<IUserRolesTableReport>> =>
  getTable<IUserRolesTableSearchParam, IUserRolesTableReport>(
    "/v1/roleAndPermission/userRoleTable",
    searchParam,
    offset,
    pageSize
  );

export const getPermissionsTable = (
  searchParam: IPermissionsTableSearchParam,
  offset: number | null,
  pageSize: number | null
): Promise<Report<IPermissionsTableReport>> =>
  getTable<IPermissionsTableSearchParam, IPermissionsTableReport>(
    "/v1/roleAndPermission/permissionTable",
    searchParam,
    offset,
    pageSize
  );

export const getRoles = (): Promise<DropdownItem[]> =>
  getRequest("/v1/RoleAndPermission/GetRoles");

export const assignRole = (
  formValues: IAssignRoleFormValues
): Promise<Packet<boolean>> =>
  postRequest("/v1/RoleAndPermission/assignRoles", formValues);
